import { render } from "./CardCarousel.vue?vue&type=template&id=626e713d&scoped=true"
import script from "./CardCarousel.vue?vue&type=script&lang=js"
export * from "./CardCarousel.vue?vue&type=script&lang=js"

import "./CardCarousel.vue?vue&type=style&index=0&id=626e713d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626e713d"]])

export default __exports__